import { Check as CheckIcon, ContentCopy as CopyIcon, Send as SendIcon } from '@mui/icons-material';
import { Button, CircularProgress, Stack } from '@mui/material';

interface TelehealthSessionInviteControlsProps {
  onCopyLink?: () => void;
  onSendLink?: () => void;
  isCopyingLink?: boolean;
  isSendingLink?: boolean;
  linkCopied?: boolean;
  subjectLabel?: string;
}

export function TelehealthSessionInviteControls({
  onCopyLink,
  onSendLink,
  isCopyingLink = false,
  isSendingLink = false,
  linkCopied = false,
  subjectLabel = 'Client',
}: TelehealthSessionInviteControlsProps) {
  if (!onCopyLink && !onSendLink) {
    return null;
  }

  return (
    <Stack direction="row" spacing={1}>
      {onCopyLink && (
        <Button
          size="small"
          variant="outlined"
          startIcon={
            isCopyingLink ? (
              <CircularProgress size={14} />
            ) : linkCopied ? (
              <CheckIcon sx={{ fontSize: 16 }} />
            ) : (
              <CopyIcon sx={{ fontSize: 16 }} />
            )
          }
          onClick={onCopyLink}
          disabled={isCopyingLink || linkCopied}
          sx={{ flex: 1, textTransform: 'none' }}
        >
          {linkCopied ? 'Copied!' : 'Copy invite link'}
        </Button>
      )}
      {onSendLink && (
        <Button
          size="small"
          variant="outlined"
          startIcon={
            isSendingLink ? <CircularProgress size={14} /> : <SendIcon sx={{ fontSize: 16 }} />
          }
          onClick={onSendLink}
          disabled={isSendingLink}
          sx={{ flex: 1, textTransform: 'none' }}
        >
          {`Send invite to ${subjectLabel}`}
        </Button>
      )}
    </Stack>
  );
}
